var resources = require('items-view-strings');
    var strings = resources['_dI6cBN5KW8i7e3SwGDOHgA'];
export { strings };
export default strings;
